import { Pipe, PipeTransform } from '@angular/core';

@Pipe( {
  name: 'AddressSort',
  pure: false
} )
export class AddressSortPipe implements PipeTransform {

  constructor () {
  }

  transform ( array: any ): any {
    let res = array;

    if ( Array.isArray( res ) && res.length >= 2 ) {
      res.sort( ( a, b ) => a.ord - b.ord );
    }

    return res;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/address-sort.pipe.ts